@if(messageMaintenance){
<td tuiTd (click)="openDialog()">
    {{ messageMaintenance.message }}
</td>
<td tuiTd class="align-right">
    <button tuiButton size="s" appearance="accent" (click)="destroy()">
        Supprimer
    </button>
</td>

} @else {
<td tuiTd class="placeholder">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vehicula pharetra nunc quis mollis.
</td>
<td tuiTd class="align-right">
    <button tuiButton size="s" appearance="accent" disabled (click)="destroy()">
        Supprimer
    </button>
</td>
}